import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["channelKey", "tabId", "tabLabel"];
import { Tab } from 'foundations-components/transitional/components/Tabs';
import { jsx as _jsx } from "react/jsx-runtime";
export function CustomTab(_ref) {
  let {
      channelKey,
      tabId,
      tabLabel
      // necessary for passing through tab data
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Tab, Object.assign({
    tabId: tabId,
    "data-tab-id": channelKey,
    "data-channel-id": channelKey,
    "data-test-id": `INTERNAL-custom-view-trigger-${tabId}`,
    title: tabLabel
  }, rest));
}
CustomTab.displayName = 'CustomTab';